import * as React from 'react';
import classnames from 'classnames';
import { CheckboxList } from '@grandvisionhq/forms';

function ItemList({ getItemIdentifier , getItemLabel , idPrefix , items , onChange , selectedItems , shouldIndent =false , getItemErrorMessage , shouldItemValidate  }) {
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('checkout__consent', {
            'checkout__consent--indent': shouldIndent
        })
    }, /*#__PURE__*/ React.createElement(CheckboxList, {
        getItemIdentifier: getItemIdentifier,
        getItemErrorMessage: getItemErrorMessage,
        shouldItemValidate: shouldItemValidate,
        idPrefix: idPrefix,
        items: items,
        onChange: onChange,
        renderItem: (item)=>/*#__PURE__*/ React.createElement("span", null, getItemLabel(item))
        ,
        selectedItems: selectedItems
    }));
}

export { ItemList };
//# sourceMappingURL=ItemList.js.map
